var _style, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkerBlueRectangular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 53.4",
    style: {
      enableBackground: "new 0 0 24 53.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 14.5718,
    cy: 10.8697,
    r: 19.867,
    fx: 5.7915,
    fy: -1.571,
    gradientTransform: "matrix(1 0 0 0.9308 0 0.7526)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    style: {
      stopColor: "#0096EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7284,
    style: {
      stopColor: "#174CAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#22298F"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.4,0 24,33 8.1,30.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.9362,
    y1: 32.6721,
    x2: 13.5032,
    y2: 47.0914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55BCEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02724212,
    style: {
      stopColor: "#50B6F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#3398F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3652,
    style: {
      stopColor: "#1C80F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5488,
    style: {
      stopColor: "#0C6FFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#0365FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0062FD"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "24,33 8.1,30.6 0,53.4 "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 0.7501,
    cy: 10.1884,
    r: 32.6494,
    fx: 18.4579,
    fy: -9.0172,
    gradientTransform: "matrix(0.5812 -0.8137 0.7574 0.541 -7.4025 5.2869)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    style: {
      stopColor: "#00F1F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5032,
    style: {
      stopColor: "#0DA3CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8446,
    style: {
      stopColor: "#1C4CA1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#22298F"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1.4,0 8.1,30.6 0,53.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkerBlueRectangular);
export default __webpack_public_path__ + "static/media/darker-blue-rectangular.ec78934424586f7c2534adada06095a0.svg";
export { ForwardRef as ReactComponent };